module.exports = __webpack_public_path__ + "static/img/pic_ai_video_5.030bd18.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_ai_video_5.gif
// module id = Dt8J
// module chunks = 1